import moment from "moment";
import { I18n } from "react-redux-i18n";
import { formatDateBilling } from "../billingOverview/component/CreditGrants/CreditGrants";

const getFields = () => [
	{
		key: 'effectiveAt',
		label: 'billingUsage.received',
		fixed: true,
		customCell: (data) => {
			return formatDateBilling(data.effectiveAt);
		}
	},
	{
		key: 'status',
		label: 'billingUsage.state',
	},
	{
		key: 'grantUsed',
		label: 'billingUsage.balance',
	},
	{
		key: 'Expires',
		label: 'billingUsage.expires',
		customCell: (data) => {
			return formatDateBilling(data.expiresAt);
		}
	},
];

const fields = getFields();
export default fields
